import React, {Component} from 'react'
import {Card} from 'reactstrap';
import SaleTimeComponent from "./SaleTimeComponent";

const storefrontUtility = require('../../utils/domain/storefrontUtility');
const formatter = require('../../utils/formatter/formatter');
const stringUtil = require('../../utils/string/stringUtil');
const translator = require('../../utils/translator/translator');
const constants = require('../../utils/domain/constants');
const saleCalculator = require('../../utils/domain/sales/saleCalculator');
const saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');

class SaleCardView extends Component 
{

    render()
    {
        let sale = this.props.sale;
        let storefrontName = null;
        let background = this.getBackgroundColor();
        let border = null;

        let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
        if (storefront != null) storefrontName = storefront.name;

        let customerName = null;
        if (!stringUtil.isStringNullOrEmpty(sale.dispatchInfo))
        {
            var dispatchInfo = JSON.parse(sale.dispatchInfo);
            customerName = dispatchInfo.customerName;
        }

        if (this.props.isSelected) border = "2px solid black";

        return <Card style={{paddingLeft:'10px', paddingRight:'10px', 
                            paddingTop:'10px', paddingBottom:'10px',
                            marginBottom:'8px', borderColor:'#A9A9A9', 
                            background:background, border:border}}
                            onClick={()=>
                            {
                                if (this.props.onSelect != null)
                                    this.props.onSelect(sale);
                            }}>

                    <div className='d-flex justify-content-between align-items-center'>

                        <div className='caption' style={{textAlign:'center'}}>
                            <div className='primary-color'>
                                {sale.number}
                            </div>
                            <div style={{color:'#7C0A02'}}>
                                {customerName}
                            </div>
                            <div>
                                {sale.dispatchType}
                            </div>
                            
                        </div>

                        <div style={{textAlign:'center'}}>
                            <div>
                                {sale.venueCode}
                            </div>
                            <div>
                                {storefrontName}
                            </div>
                            <div className='hint-text'>
                                <SaleTimeComponent sale={this.props.sale}/>
                            </div>
                        </div>
                        

                        <div className='hint-text' style={{textAlign:'end'}}>

                            <div>
                                {translator.getLabel("total_sale_price")}: {formatter.convertToCurrencyFormat(saleCalculator.calculateTotalSalePrice(sale))}
                            </div>

                            <div>
                                {translator.getLabel("total_discount")}: {formatter.convertToCurrencyFormat(saleCalculator.calculateTotalDiscounts(sale))}
                            </div>

                            <div>
                                {translator.getLabel("net_sale_price")}: {formatter.convertToCurrencyFormat(saleCalculator.calculateTotalNetSalePrice(sale))}
                            </div>
                                {this.getSaleStatusComponent()}
                            <div>
                                {translator.getLabel("payment_status")}: {this.getPaymentStatusComponent()}
                            </div>
                        </div>
                    </div>
                </Card>
    }

    getSaleStatusComponent()
    {
        let sale = this.props.sale;

        if (saleCommonUtility.isSaleHoldByStaff(sale))
        {
            return <div>
                        {translator.getLabel("sale_status")}: 
                        <span style={{background:'#585858', color:'white', 
                                      paddingLeft:'5px', paddingRight:'5px', marginLeft:'5px'}}>
                            {translator.getLabel("sale_status_hold_by_staff")}
                        </span>
                    </div>
        }

        if (saleCommonUtility.isCancelled(sale))
        {
            return <div>
                        {translator.getLabel("sale_status")}: 
                        <span style={{background:'#585858', color:'white', 
                                      paddingLeft:'5px', paddingRight:'5px', marginLeft:'5px'}}>
                            {translator.getLabel("sale_status_cancelled")}
                        </span>
                    </div>
        }

        if (saleCalculator.isSaleFullyRefunded(sale))
        {
            return <div>
                        {translator.getLabel("sale_status")}: 
                        <span style={{background:'#585858', color:'white', 
                                      paddingLeft:'5px', paddingRight:'5px', marginLeft:'5px'}}>
                            {translator.getLabel("sale_status_fully_refunded")}
                        </span>
                    </div>
        }

        if (saleCalculator.calculateTotalRefunds(sale) > constants.numericThresholdValue)
        {
            return <div>
                        {translator.getLabel("sale_status")}: 
                        <span style={{background:'#585858', color:'white', 
                                      paddingLeft:'5px', paddingRight:'5px', marginLeft:'5px'}}>
                            {translator.getLabel("sale_status_partially_refunded")}
                        </span>
                    </div>
        }
   
        return null;
    }

    getPaymentStatusComponent()
    {
        let sale = this.props.sale;

        if (saleCalculator.isSaleFullyPaid(sale))
            return <span className='hint-text' style={{background:'green', color:'white', 
                                                       paddingLeft:'10px', paddingRight:'10px'}}>
                        {translator.getLabel("paid")}
                    </span>

        return <span  className='hint-text' style={{background:'red', color:'white', 
                                                    paddingLeft:'5px', paddingRight:'5px'}}>
                    {translator.getLabel("not_paid")}
                </span>
    }

    getBackgroundColor()
    {
        if (this.props.sale.saleType != constants.SaleTypeSale)
            return "#cfd1d2";

        if (this.props.sale.dispatchType == constants.DispatchTypeDineIn)
            return "#D3EEB9"

        if (this.props.sale.dispatchType == constants.DispatchTypeTakeAway)
            return "#C7EAEE"
        
        if (this.props.sale.dispatchType == constants.DispatchTypeCollection)
            return "#F8E4B2"    
        

        if (this.props.sale.dispatchType == constants.DispatchTypeDelivery)
            return "#FFCCCB"    
    }
}

export default SaleCardView